<template>
  <div class="opportunity-button-wrapper">
    <woot-button
      v-if="!opportunity"
      color-scheme="primary"
      class-names="opportunity-action-button"
      icon="deal-icon"
      @click="$emit('open-create-modal')"
    >
      {{ $t('OPPORTUNITY_DETAILS.CREATE_MODAL.CREATE_BUTTON') }}
    </woot-button>
    <woot-button
      v-else
      color-scheme="primary"
      class-names="opportunity-action-button"
      icon="deal-icon"
      @click="$emit('open-sidebar')"
    >
      {{ valueFormatted }}
    </woot-button>
  </div>
</template>

<script>
export default {
  name: 'OpportunityActionButton',
  props: {
    opportunity: {
      type: Object,
      default: null,
    },
  },
  computed: {
    valueFormatted() {
      if (!this.opportunity) {
        return '';
      }

      const amount = Number(this.opportunity.value || 0);
      return `${this.opportunity.currency || 'BRL'} ${amount.toLocaleString(
        'pt-BR',
        {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }
      )}`;
    },
  },
};
</script>

<style scoped lang="scss">
.opportunity-button-wrapper {
  display: flex;
  align-items: center;
}

::v-deep .opportunity-action-button {
  background: var(--o-500);
  color: var(--v-50);

  &:hover {
    background: var(--o-600);
  }
}
</style>
